import { Injectable, inject } from '@angular/core';
import { Router, UrlSegment } from '@angular/router';
import { StartupService } from '@core/bootstrap/startup.service';

@Injectable({
  providedIn: 'root',
})
export class MenuGuard {
  private startupService = inject(StartupService);
  private router = inject(Router);

  async canLoad(route: UrlSegment): Promise<boolean> {
    let menu = this.startupService.menuJson;

    // Die Router-Initial-Navigation laeuft parallel zum StartupService-
    // APP_INITIALIZER — bei Deep-Links kann das Menue hier noch fehlen.
    if (!menu) {
      try {
        await this.startupService.load();
      } catch {
        // StartupService zeigt seinen eigenen Fehler (Preloader)
      }
      menu = this.startupService.menuJson;
    }

    if (typeof menu !== 'object' || menu === null || !Object.keys(menu).includes(route.path)) {
      console.warn('[MenuGuard] menuJson missing or does not contain route:', route.path);
      this.router.navigate(['']);
      return false; // Optional: might want to return false to block the route
    }
    return true;
  }
}
